import { AppDataState } from './app-data-store';
import { EventItem } from './interface/event-item';

export const SET_EVENT_ITEMS = 'SET_EVENT_ITEMS';

export type SetEventItemsAction = {
  type: typeof SET_EVENT_ITEMS;
  payload: EventItem[];
};

// redux update store action
export const setEventItemsAction = (payload: EventItem[]): SetEventItemsAction => {
  return {
    type: SET_EVENT_ITEMS,
    payload,
  };
};

// redux reducer handler - state updater
export const setEventItemsHandler = (
  state: AppDataState,
  action: SetEventItemsAction
): AppDataState => {
  return {
    ...state,
    eventItems: action.payload,
  };
};
